module.exports = __webpack_public_path__ + "static/mvid-5c4d3f3249dd1fb11fb94128edc7edf9.gif";